export enum DeliveryMethod {
	delivery = 'delivery',
	takeout = 'takeout',
}

export const deliveryMethodLabels = {
	[DeliveryMethod.delivery]: 'Entrega',
	[DeliveryMethod.takeout]: 'Retirada',
};
